export default {
    namespaced: true,
    state: {
        voiceBroadcastSwitch: false, // 语音播报-开关
        voiceDictationSwitch: false, // 语音听写-开关
        voiceInteractionSwitch: false, // 语音交互-开关
    },
    mutations: {
        setVoiceBroadcastSwitch(state, data) {
            state.voiceBroadcastSwitch = data
        },
        setVoiceDictationSwitch(state, data) {
            state.voiceDictationSwitch = data
        },
        setVoiceInteractionSwitch(state, data) {
            state.voiceInteractionSwitch = data
        },
    },
}